import classes from "./BannerCaption.module.scss";

interface BannerCaptionProps {
  caption?: string;
}

export const BannerCaption = ({ caption = "" }: BannerCaptionProps) => {
  if (!caption) return null;

  return (
    <div className={classes["banner-caption"]}>
      <p>{caption}</p>
    </div>
  );
};
